import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Products = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, [language]);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API}/products?language=${language}`);
      setProducts(response.data);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    }
  };

  return (
    <div className="page-container min-h-screen py-8 bg-gradient-to-br from-blue-50 via-white to-mint-50">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h1 className="mb-4 text-4xl font-bold text-slate-900 sm:text-5xl" data-testid="products-title">
            {t('products.title')}
          </h1>
          <p className="text-lg text-slate-600">{t('products.subtitle')}</p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {products.map((product) => (
            <Card
              key={product.id}
              className="group cursor-pointer overflow-hidden border-0 shadow-lg transition-all hover:shadow-2xl"
              onClick={() => navigate(`/products/${product.slug}`)}
              data-testid={`product-${product.slug}`}
            >
              {product.image_url && (
                <div className="h-56 overflow-hidden">
                  <img
                    src={product.image_url}
                    alt={product.title}
                    className="h-full w-full object-cover transition-transform group-hover:scale-105"
                  />
                </div>
              )}
              <CardContent className="p-6">
                {product.badge && (
                  <Badge className="mb-3 bg-teal-600">{product.badge}</Badge>
                )}
                <h2 className="mb-3 text-2xl font-bold text-slate-900 group-hover:text-teal-600">
                  {product.title}
                </h2>
                <p className="mb-4 text-slate-600">{product.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-teal-600">{product.price}</span>
                  <Button className="bg-teal-600 hover:bg-teal-700" data-testid={`product-button-${product.slug}`}>
                    {t('products.getAccess')}
                    <ExternalLink className="ml-2 h-4 w-4" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;